// extracted by mini-css-extract-plugin
module.exports = {"mainRoot":"index-mainRoot-1HPbM","pageItem":"index-pageItem-TRCSQ","footer":"index-footer-2wEIW"};